import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from 'environments/environment';
import {ToastrService} from 'ngx-toastr';
import {catchError, Observable, throwError} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DisinfectionprogramService {
    constructor(
        private httpClient: HttpClient,
        private toastr: ToastrService
    ) {}
    private apiUrl = environment.apiUrl;

    getDisInfectionProgramList(): Observable<any> {
        return this.httpClient
            .get(`${this.apiUrl}/DisinfectionProgram/DisInfectionProgramList`)
            .pipe
            // catchError(this.error)
            ();
    }
    getDisInfectionById(id: number): Observable<any> {
        return this.httpClient
            .get(
                `${this.apiUrl}/DisinfectionProgram/GetDisinfectionById?id=${id}`
            )
            .pipe
            //catchError(this.error)
            ();
    }
    addDisInfection(disinfectionModel: any): Observable<any> {
        return this.httpClient
            .post(
                `${this.apiUrl}/DisinfectionProgram/AddDisInfections`,
                disinfectionModel
            )
            .pipe
            //catchError(this.error)
            ();
    }
    updateDisInfection(disinfectionModel: any): Observable<any> {
        return this.httpClient
            .post(
                `${this.apiUrl}/DisinfectionProgram/UpdateDisInfection`,
                disinfectionModel
            )
            .pipe
            //catchError(this.error)
            ();
    }
    getDisInfectionList(
        userId: number,
        page: number,
        pageSize: number,
        programName?: string,
        disinfectionTypeId?: number
    ): Observable<any> {
        let params = `userId=${userId}&page=${page}&pageSize=${pageSize}`;

        if (programName) {
            params += `&programName=${encodeURIComponent(programName)}`;
        }

        if (disinfectionTypeId) {
            params += `&disinfectionTypeId=${disinfectionTypeId}`;
        }

        return this.httpClient
            .get(
                `${this.apiUrl}/DisinfectionProgram/GetDisInfectionList?${params}`
            )
            .pipe
            //catchError(this.error)
            ();
    }
    getDisInfectionInstructionList(id: any): Observable<any> {
        return this.httpClient
            .get(
                `${this.apiUrl}/DisinfectionProgram/GetInstructionListByProgramId?id=${id}`
            )
            .pipe
            //catchError(this.error)
            ();
    }

    getDisinfectionList(): Observable<any> {
        return this.httpClient
            .get(`${this.apiUrl}/DisinfectionProgram/DisInfectionList`)
            .pipe
            //catchError(this.error)
            ();
    }
    deleteDisinfectionProgram(id: number) {
        return this.httpClient.post(
            `${this.apiUrl}/DisinfectionProgram/DeleteDisInfection?id=${id}`,
            {}
        );
    }
}
